if(typeof BSS_B2B != undefined) {
  if(window.location.pathname.includes("/pages/wholesale-account-registration")) {
    setTimeout(() =>{
      //default field
      // $(".field").each(function (ind, item) {
      //   const input = $(item).find("input");
      //   const label = $(item).find("label");
      //   if (input && label) {
      //     $(input).attr("placeholder", $(label).text());
      //       $(label).css("display", "none");
      //   }
      // })
      const btnSubmit = $("#MainContent input[type='submit']");
      if (btnSubmit.length) {
        btnSubmit.val("Apply");
      }
    },200)
  }

 if(window.location.pathname.includes("/products")) {
   setTimeout(() =>{
      const targetProduct = document.querySelector("form[action='/cart/add'] input[name='id']");
      if (targetProduct) {
        const mutationObserver = new MutationObserver((recordList, observe) => {
            setTimeout(() =>{
                $('[bss-b2b-product-active]').removeAttr("bss-b2b-product-active");
                BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, false);
            }, 500)
            
        });
        mutationObserver.observe(targetProduct, { attributes: true });
      }
   }, 500)
 }
 if(window.location.pathname.includes("/cart")) {
   setTimeout(() =>{
    const targetCart = document.querySelector(".cart__items");
    if (targetCart) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
          BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
      });
      mutationObserver.observe(targetCart, { attributes: true });
    }
   }, 500)
 }
}